/**
 * Scroll controls for the brand logo row.
 *
 * The row itself is a plain CSS scroll container, so it works without JS —
 * this element only adds the arrow buttons on top, enables them when there is
 * something to scroll to, and hides them entirely when everything fits.
 */
class LogoRow extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-logo-track]');
    this.prev = this.querySelector('[data-logo-prev]');
    this.next = this.querySelector('[data-logo-next]');

    if (!this.track) return;

    this.onScroll = () => this.updateControls();
    this.onResize = () => this.updateControls();

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    this.prev?.addEventListener('click', () => this.scrollByPage(-1));
    this.next?.addEventListener('click', () => this.scrollByPage(1));

    this.resizeObserver = new ResizeObserver(this.onResize);
    this.resizeObserver.observe(this.track);

    this.updateControls();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    this.resizeObserver?.disconnect();
  }

  /** @param {number} richtung -1 = back, 1 = forward */
  scrollByPage(richtung) {
    const schritt = Math.max(this.track.clientWidth * 0.8, 200);
    this.track.scrollBy({
      left: schritt * richtung,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }

  updateControls() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    // 2px tolerance — sub-pixel layouts never hit the exact end.
    const amAnfang = scrollLeft <= 2;
    const amEnde = scrollLeft + clientWidth >= scrollWidth - 2;
    const scrollbar = scrollWidth > clientWidth + 2;

    this.classList.toggle('logo-row--scrollable', scrollbar);

    if (this.prev) {
      this.prev.disabled = amAnfang;
      this.prev.hidden = !scrollbar;
    }
    if (this.next) {
      this.next.disabled = amEnde;
      this.next.hidden = !scrollbar;
    }
  }
}

if (!customElements.get('logo-row')) {
  customElements.define('logo-row', LogoRow);
}
